import { connect } from 'react-redux';
import LeadNote from '../components/OrderDashboardPages/pages/LeadNote';
import { getUser as getUserSelector } from '../redux/selectors/accountSettingSelector';
import { getPersonLeadNoteStatus } from '../redux/actions/CurrentPersonStatus';
import { getUser } from '../redux/actions/AccountSetting';
import { goBack, push } from "react-router-redux";

const mapStateToProps = (state) => ({
  user: getUserSelector(state),
  pageInfo: state.currentPersonStatus.pageInfoLeadNote,
  isLoading: state.currentPersonStatus.isLoadingLeadNote,
  list: state.currentPersonStatus.leadNoteList,
})

const mapDispatchToProps = dispatch => ({
  getPersonLeadNoteStatus(data, overwrite) {
    dispatch(getPersonLeadNoteStatus(data, overwrite))
  },

  getUserInfo() {
    dispatch(getUser());
  },

  goBack() {
    dispatch(goBack());
  },

  goTo(url, state) {
    dispatch(push(url, state));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(LeadNote);



// WEBPACK FOOTER //
// ./src/containers/LeadNote.js